<template>
  <v-layout
    
    column
    justify-start
    :class="!bMini ? 'viewLayoutWrapper MiniPadding' : 'viewLayoutWrapper'"
  >
    <!-- Start title -->
    <p class="SectionTitle">Órdenes de compra</p>
    <!-- End title -->
    <!-- Start search component -->
    <search-appointments :mdUp="mdUp" :smUp="smUp" @getDateRange="getDateRange" @setSearchType="setSearchType"> </search-appointments>
    <!-- End search component -->
    <!-- Start table component -->
    <table-appointments :oDateRange="oDateRange" :sSearchType="sSearchType" :mdUp="mdUp" :smUp="smUp"> </table-appointments>
    <!--
                <v-layout row justify-center>
        <v-pagination
          color="primary"
          v-model="iCurrentPage"
          :length="iPageNumber"
        ></v-pagination>
      </v-layout>-->
    <!-- End table component -->
  </v-layout>
</template>
<script>
export default {
  data() {
    return {
      oDateRange: {},
      sSearchType:"2"
    }
  },
  components: {
    // import search component
    SearchAppointments: () => import("../../components/views/Orders/Search"),
    // import search component
    TableAppointments: () => import("../../components/views/Orders/Table"),
  },
  props: {
    // import texts from admin
    texts: Object,
    mdUp: Boolean,
    smUp: Boolean,
    bMini: Boolean,
  },
  methods: {
    getDateRange(oDateRange) {
      this.oDateRange = oDateRange;
    },
    setSearchType(sSearchType) {
      this.sSearchType = sSearchType;
    }
  },
  computed: {
    // section texts
    sectionTxt() {
      return this.texts.orders;
    },
  },
};
</script>
